// extracted by mini-css-extract-plugin
export default {"form":"HrCreateNewUser_form__U5wZT","error-message":"HrCreateNewUser_error-message__WD7Gx"};